import {
  borderWidthVars,
  fontSizeVars,
  fontWeightVars,
  lineHeightVars,
  radiusVars,
  spacingVars,
} from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';
import { style, styleVariants } from '@vanilla-extract/css';

const INDICATOR_SIZE = `calc(${lineHeightVars.body.body2} + (${spacingVars.sm} * 2))`;
const LINE_WIDTH = 2;
const SIDEBAR_Z_INDEX = 2;

export const wrapperClass = style({
  position: 'relative',
  zIndex: SIDEBAR_Z_INDEX,
  display: 'flex',
  flexDirection: 'column',
  gap: spacingVars.xl,
  height: '100%',
  width: '100%',
});

export const navClass = style({
  flex: 1,
  minHeight: 0,
  marginTop: spacingVars['3xl'],
});

export const listClass = style({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  gap: spacingVars.sm,
  margin: 0,
  padding: 0,
  listStyle: 'none',
});

export const itemClass = style({
  display: 'flex',
  flexDirection: 'column',
  gap: spacingVars.sm,
});

export const connectorClass = style({
  width: LINE_WIDTH,
  height: spacingVars.lg,
  marginLeft: `calc(${INDICATOR_SIZE} / 2)`,
  borderRadius: radiusVars.sm,
  backgroundColor: semanticTokenVars.surface.background.brand.default.subtle,
});

export const stepButtonClass = style({
  display: 'flex',
  alignItems: 'center',
  gap: spacingVars.sm,
  width: '100%',
  padding: 0,
  border: 'none',
  background: 'none',
  textAlign: 'left',
  cursor: 'pointer',
  color: semanticTokenVars.content.onBrand.default,
  fontSize: fontSizeVars.body.body2,

  selectors: {
    '&:focus-visible': {
      outline: `${borderWidthVars.xs} solid ${semanticTokenVars.content.onBrand.default}`,
      outlineOffset: spacingVars.xs,
    },
    '&:disabled': {
      cursor: 'default',
    },
  },
});

export const indicatorClass = style({
  display: 'flex',
  flexShrink: 0,
  alignItems: 'center',
  justifyContent: 'center',
  width: INDICATOR_SIZE,
  height: INDICATOR_SIZE,
  borderRadius: radiusVars.md,
  borderStyle: 'solid',
  borderWidth: borderWidthVars.xs,
  borderColor: 'transparent',
  fontSize: fontSizeVars.body.body2,
  lineHeight: lineHeightVars.body.body2,
});

export const indicatorVariants = styleVariants({
  completed: {
    borderColor: semanticTokenVars.border.onBrand.default,
    color: semanticTokenVars.content.onBrand.default,
  },
  current: {
    backgroundColor: semanticTokenVars.border.onBrand.default,
    color: semanticTokenVars.content.onBrand.onInverse,
    fontWeight: fontWeightVars.bold,
  },
  upcoming: {
    backgroundColor: semanticTokenVars.surface.background.brand.default.subtle,
    color: semanticTokenVars.content.onBrand.default,
    fontWeight: fontWeightVars.regular,
  },
});

export const checkIconClass = style({
  fontSize: lineHeightVars.body.body2,
  color: semanticTokenVars.content.onBrand.default,
});

export const labelClass = style({
  flex: 1,
  minWidth: 0,
  color: semanticTokenVars.content.onBrand.default,
});

export const labelVariants = styleVariants({
  completed: { fontWeight: fontWeightVars.regular },
  current: { fontWeight: fontWeightVars.bold },
  upcoming: { fontWeight: fontWeightVars.regular },
});

export const bottomCtaClass = style({
  flexShrink: 0,
});

export const headerClass = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '100%',
});

export const dividerClass = style({
  flexShrink: 0,
  height: borderWidthVars.xs,
  marginInline: spacingVars.lg,
  backgroundColor: semanticTokenVars.border.onBrand.default,
});

export const footerClass = style({
  display: 'flex',
  flexDirection: 'column',
  gap: spacingVars.md,
  flexShrink: 0,
});

export const poweredByClass = style({
  display: 'flex',
  alignItems: 'center',
  gap: spacingVars.sm,
  color: semanticTokenVars.content.onBrand.default,
  fontSize: fontSizeVars.body.body3,
});

export const poweredByLogoClass = style({
  flexShrink: 0,
});
